import { createReducer } from 'redux-starter-kit';
import { fetchInspectionListPageData, setLoadParameters } from './inspectionListUiActions';
import { selectRequest } from '../../domain/requests/RequestReducer';
import {getLastWeekDateRange} from "../../../sections/secured/bynx/packageUtil";


/**
 * A selector that returns the state of the 'FETCH_INSPECTION_LIST_PAGE_DATA' action.
 */
export const selectInspectionListPageDataRequest = (state) => {
  const requestId = state.via.ui.inspectionList.requestInspectionListPageDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

const listInitialState = {
  requestInspectionListPageDataId: null,
  filterLoadParameters: {
    my: false,
    compliance: false,
    other: false,
    defects: false,
    noDefects: false,
    faults: false,
    damages: false,
    costs: false,
    dates: getLastWeekDateRange(),
  },
};

/**
 * Get loading filter parameters
 */
export const selectFilterLoadParameters = (state) => {
  const parms = state.via.ui.inspectionList.filterLoadParameters;
  return parms != null ? parms : listInitialState.filterLoadParameters;
};

// REDUCER
const inspectionListUIReducer = createReducer(listInitialState, {
  // A new request has been made to load all the page data
  [fetchInspectionListPageData]: (state, action) => ({
    ...state,
    requestInspectionListPageDataId: action.payload,
  }),

  // Set load parameters
  [setLoadParameters]: (state, action) => ({
    ...state,
    filterLoadParameters: action.payload,
  }),
});

export default inspectionListUIReducer;
